import { ReactElement } from 'react';

import { useHirePlanFormStepStore } from '../../../stores/useHirePlanFormStepStore';
import { ConfirmForm } from './steps/ConfirmForm';
import ValidacaoCadastro from '../../../pages/AuthOdontoGroup';
import FunctionaryForm from './steps/functionary/functionaryForm';

export function HirePlanFormStepHandler(): ReactElement {
  const step = useHirePlanFormStepStore(state => state.step);

  switch (step) {
    case 1: {
      return <FunctionaryForm />;
    }

    case 2: {
      return <ConfirmForm />;
    }

    case 3: {
      return <ConfirmForm />;
    }

    default: {
      return <ValidacaoCadastro />;
    }
  }
}
